export default __webpack_public_path__ + "static/media/interface-16.fa70fb59.png";